
let app = new Vue({
    el: '#admin_service',

    data: {
        output: '',
        submitting: false,
        successClass: '',
    },
    watch: {
        submitting() {
            if(this.submitting) {
                $("#overlay").show();
            } else {
                $("#overlay").hide();
            }
        }
    },
    methods: {
        dumpDb(event) {
            let url = event.target.getAttribute('data-url');
            this.submitting = true;
            axios.get(url).then((response) => {
               console.log(response.data);
               if(response.data.success) {
                   this.successClass = 'success';
               } else {
                   this.successClass = 'error';
               }
               this.output = unescape(response.data.message);
               this.submitting = false;
            });
        },
        importProduction(event) {
            swal({
                title: 'Daten importieren ab Tag.Monat.Jahr',
                html: '<label>Import ab:</label><input id="swal-input1" class="swal2-input">',
                text: 'Haben Sie an das Backup gedacht?',
                showCancelButton: true,
                confirmButtonText: 'Jetzt importieren',
            }).then((result) => {
                if (result.value) {
                    this.submitting = true;
                    let idate = $("#swal-input1").val();
                    axios.post('/admin/importClients', {start: idate}).then((response) => {
                        this.responseCallback(response);
                    }).then(() => {
                        axios.post('/admin/importVip', {start: idate}).then((response) => {
                            this.responseCallback(response);
                        }).then(() => {
                            axios.post('/admin/importVps', {start: idate}).then((response) => {
                                this.responseCallback(response);
                            });
                        }).then(() => {
                            axios.post('/admin/importCrv', {start: idate}).then((response) => {
                                this.responseCallback(response);
                                this.submitting = false;
                            });
                        });
                    });
                }
            })
        },
        responseCallback(response) {
            if (response.data.success) {
                this.successClass = 'success';
            } else {
                this.successClass = 'error';
            }
            this.output = this.output + unescape(response.data.message);
        },
        clearLog(event) {
            var url = event.target.getAttribute('data-url');
            swal({
                title: 'Logeinträge löschen älter als Tag.Monat.Jahr',
                input: 'text',
                inputAttributes: {
                    autocapitalize: 'off',
                    name: 'date'
                },
                showCancelButton: true,
                confirmButtonText: 'Jetzt bereinigen',
            }).then((result) => {
                if (result.value) {
                    this.submitting = true;
                    axios.post(url, {olderThen: $("input[name=date]").val()}).then((response) => {
                        console.log(response.data);
                        if (response.data.success) {
                            this.successClass = 'success';
                        } else {
                            this.successClass = 'error';
                        }
                        this.output = unescape(response.data.message);
                        this.submitting = false;
                    });
                }
            })
        },
        deleteBookings(event) {
            var url = event.target.getAttribute('data-url');
            swal({
                title: 'Buchungen löschen älter als Tag.Monat.Jahr',
                input: 'text',
                inputAttributes: {
                    autocapitalize: 'off',
                    name: 'date'
                },
                text: 'Haben Sie an das Backup gedacht? Löschen kann nicht rückgängig gemacht werden.',
                showCancelButton: true,
                confirmButtonText: 'Jetzt löschen',
            }).then((result) => {
                if (result.value) {
                    this.submitting = true;
                    var idate = $("input[name=date]").val();
                    axios.post(url, {olderThen: idate}).then((response) => {
                        console.log(response.data);
                        if (response.data.success) {
                            this.successClass = 'success';
                        } else {
                            this.successClass = 'error';
                        }
                        this.output = unescape(response.data.message);
                        this.submitting = false;
                    });
                }
            })
        }
    }

});

export default app;